import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-pro-marcas-huertos',
  templateUrl: './marcas-huertos.component.html'
})
export class MarcasHuertosComponent implements OnInit {

  private readonly _DEFAULT_ITEMS_PER_PAGE = 10;

  public marcasHuertosList;

  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 0; // La paginación en back empieza por 0, como los arrays.
  public totalItems: number;
  public readonly visiblePages = 3;

  @Input() productorId;
  @Input() marcasHuertos;

  constructor(
    private readonly _translate: TranslateService) { }

  ngOnInit() {
    this.marcasHuertosList = this.marcasHuertos;
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
}

}
